<template>
  <Spinner v-if="loading"></Spinner>
  <div v-else>
    <v-snackbar center color="green" v-model="snackbar">
      <div class="text-center">{{ message }}</div>
    </v-snackbar>

    <!--<AddEditPoll
      @dialog="dialog = $event"
      @update="[(selectedPoll = $event), buildTable()]"
      :dialog="dialog"
      :poll="selectedPoll"
    />-->
    <v-breadcrumbs :items="crumbs">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-card>
      <v-card-text>
        <v-data-table
          dense
          :items-per-page="100"
          class="sortable-table"
          :headers="headers"
          :items="polls"
          item-text="pollText"
          item-value="_id"
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar-title class="mb-6" flat color="white">
              <v-btn
                right
                fab
                absolute
                color="primary"
                @click="addItem()"
                dark
                class=""
                ><v-icon>mdi-plus</v-icon></v-btn
              >
              <v-toolbar-title class=""
                >Manage Polls
                <small>(event Id: {{ event._id }})</small></v-toolbar-title
              >

              <v-spacer></v-spacer>
            </v-toolbar-title>
          </template>
          <template v-slot:item="{ item }">
            <tr class="item" :key="item._id">
              <td><v-icon class="handle">mdi-drag</v-icon></td>
              <td>
                <router-link :to="'/admin/launch/' + item._id"
                  ><strong>{{ item.pollText }}</strong></router-link
                ><br /><v-chip
                  class="mr-1"
                  small
                  v-for="tag in item.tags"
                  v-bind:key="tag"
                  >{{ tag }}</v-chip
                >
              </td>
              <td>
                <v-chip v-if="item.active" color="red" small dark
                  >in progress</v-chip
                >
              </td>
              <td>{{ item.totalVotes }}</td>
              <td>
                {{ item.showResults }}
              </td>
              <td>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editPoll(item)">
                      <v-list-item-title>Edit poll</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="clonePoll(item)">
                      <v-list-item-title>Clone this poll</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="clearResponses(item)">
                      <v-list-item-title>Clear Responses</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deletePoll(item)">
                      <v-list-item-title>Delete poll</v-list-item-title>
                    </v-list-item>
                  </v-list></v-menu
                >
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/services/api";
import { mapState } from "vuex";
import Sortable from "sortablejs";
import Spinner from "@/components/Elements/Spinner.vue";
export default {
  name: "DataTable",
  components: {
    Spinner
  },
  data: () => ({
    loading: false,
    crumbs: [
      {
        text: "Home",
        to: "/admin",
        exact: true
      },
      {
        text: "Polls",
        to: "/admin/polls",
        exact: true
      }
    ],
    snackbar: false,
    message: "",
    socket: null,
    dialogTitle: "",
    defaultPoll: {
      pollText: "",
      pollAnswers: []
    },
    selectedPoll: {},
    dialog: false,
    headers: [
      { text: "Sort", value: "", width: 0, sortable: false },
      { text: "Poll Question", value: "pollText" },
      { text: "", value: "active" },
      { text: "Votes", value: "totalVotes" },
      { text: "Show Results", value: "showResults" },
      { text: "", value: "actions", sortable: false }
    ],
    polls: []
  }),
  computed: {
    ...mapState({
      event: (state) => state.events.event
    })
  },
  async created() {
    await this.buildTable();

    let table = document.querySelector(".sortable-table tbody");

    const _self = this;
    Sortable.create(table, {
      animation: 200,
      handle: ".handle",
      draggable: ".item",
      onEnd({ newIndex, oldIndex }) {
        // Get the selected row and remove it
        const rowSelected = _self.polls.splice(oldIndex, 1)[0];
        // Move it to the new index
        _self.polls.splice(newIndex, 0, rowSelected);
        // prepare a list for the new order to save to database
        const orderArray = _self.polls.map((item, index) => {
          return { _id: [item._id], index: index };
        });

        _self.$store.dispatch("reorderPolls", orderArray);
      }
    });
  },
  mounted() {},
  methods: {
    async buildTable() {
      this.loading = true;
      this.polls = await this.$store.dispatch("loadPolls");
      this.loading = false;
    },
    async addItem() {
      this.$router.replace(`/admin/polls/create`);
      //this.selectedPoll = Object.assign({}, this.defaultPoll);
      //this.selectedPoll.pollAnswers = new Array();
    },
    async editPoll(item) {
      this.$router.replace(`/admin/polls/edit/${item._id}`);
      //this.answers = await this.$store.dispatch('loadAnswers', this.poll._id);
      //this.dialog = true;
      //this.selectedPoll = Object.assign({}, item);
      //this.selectedPoll.pollAnswers = item.pollAnswers.slice();
    },
    async deletePoll(item) {
      if (confirm("Are you sure you want to delete this poll?")) {
        await this.$store.dispatch("deletePoll", item);

        this.buildTable();
      }
    },
    async clearResponses(poll) {
      if (confirm("Are you sure you want to clear responses?")) {
        const response = await api.clearResponses(poll._id);
        this.buildTable();
        this.message = `Successfully cleared ${response.result.deletedCount} responses`;
        this.snackbar = true;
      }
    },
    async clonePoll(item) {
      if (confirm("Are you sure you want to clone this poll?")) {
        await api.clonePoll(item._id);
        this.buildTable();
      }
    },
    async toggleShowResults(item) {
      await api.updatePoll(item._id, {
        showResults: item.showResults || item.showResults
      });
      this.buildTable();
    }
  }
};
</script>
